var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"link",staticClass:"grid-x grid-padding-x inline-link",attrs:{"tabindex":"0"},on:{"click":_vm.clicked,"keyup":_vm.clicked}},[_c('div',{staticClass:"small-12 cell vertical-align-middle inline-link-text"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }